var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},[_c('h3',{staticClass:"lesson-subheading"},[_vm._v("Which arrangement is the best?")]),_c('hr',{staticClass:"subheading-separator"}),_c('app-play-game',{attrs:{"gameRule":_vm.gameRule,"numberOfGames":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }